import { render } from "./Carousel.vue?vue&type=template&id=af737e36"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/reahmiyara/Code/226CliftonPlace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__